import React from 'react'
import styles from './index.module.scss'
import { tools, QRcode, tip } from 'portal/assets/images/index'


interface ToolsProps {
  image: string,
  title: string,
}
export default function ResearchTools() {
  const toolsData: ToolsProps[] = [
    {
      image: tools,
      title: '独立样本t检验',
    },
    {
      image: tools,
      title: 'Pearson相关分析',
    },
    {
      image: tools,
      title: '大数据关联分析',
    },
  ]

  function toolsCard(props: ToolsProps) {
    const { image, title } = props
    return(
      <div style={{ margin: '30px 10px 30px', cursor: 'pointer' }}>
        <img style={{ width: 185, height: 136 }} src={ image } alt="效率工具"/>
        <p style={{ width: 185, height: 63, lineHeight: '63px',textAlign: 'center',fontSize: 16, color: '#202d4c', border: '1px solid #E8E8E8', borderTop: 'none', margin: 0, marginTop: -4 }}>{ title }</p>
      </div>
    )
  }
  return (
    <div className={ styles.researchTools}>
      <h2>效率工具 <span> Research Tools</span></h2>
      <div style={{ display: 'flex' }}>
        <div style={{ width: 860, display: 'flex', background:'#fff', position: 'relative' }}>
          <a href="/apps/sat" target="_blank" rel="noopener noreferrer">
            <img src={ tools } alt="在线统计工具" style={{ margin: '30px 10px 30px 30px', cursor: 'pointer' }}/>
            <div style={{ position: 'absolute',top: 50, left: 50 }}>
              <p style={{ color: '#fff', fontSize: 18 }}>在线统计工具</p>
              <p>
                <img src={ tip } alt="开始探索"/>
                <span style={{ color: '#fff' }}>开始探索</span>
              </p>
            </div>
          </a>
          { toolsData.map(toolsCard) }
        </div>
        <div style={{ width: 320, height: 260, background: '#fff', marginLeft: 20, textAlign: 'center' }}>
          <h6 style={{ fontSize: 20, fontWeight: 500, color: '#202d4c', marginTop: 30 }}>方法学门诊</h6>
          <p style={{ fontSize: 14, color: '#95a4bd', marginBottom: 15 }}>预约统计专家的方法学门诊</p>
          <img src={ QRcode } alt="二维码"/>
        </div>
      </div>
    </div>
  )
}
